var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h1',{staticClass:"title text-black fw-bold"},[_vm._v("Women")]),_c('ItemList',{staticClass:"card-item",attrs:{"products":this.$store.state.women,"image":_vm.image}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }